import { money } from "../../utils/helpers";
import { formatPhone } from "../../utils/sanitize";
import { Card } from "../../utils/ui.jsx";
import { ApprovalDecisions } from "./ApprovalDecisions.jsx";
import { SectionTitle } from "./RequestDetailAtoms.jsx";
import { ShelterInfoBox } from "./RequestDetailPanels.jsx";

export function LeftPanel({
  req,
  user,
  isStaff,
  isPicker,
  status,
  setStatus,
  deriveStatus,
  setNotes,
  setNote,
  setShowCommentPanel,
  showSaved,
  onSaveNoDb,
  submitToSchoolLocker,
  totals,
}) {
  const { feeTotal, slTotal, uniTotal, shoeTotal, laptopTotal, hasLaptops, grand } = totals;
  return (
    <div>
      <Card style={{ marginBottom: 14 }}>
        <SectionTitle>General Information</SectionTitle>
        {[
          ["Zephyr Ref", req.refNo],
          ["DFV Service Ref", req.shelterRef],
          ["DFV Service", req.shelterName],
          ["Contact Name", req.contactName],
          // Mobile on the LHS, Phone on the RHS (space-between); a lone number
          // sits on the left rather than being floated right by an empty slot.
          [
            "Mobile / Phone",
            req.mobile || req.phone ? (
              <div
                key="nums"
                style={{ display: "flex", justifyContent: "space-between", width: "100%", gap: 14 }}
              >
                {req.mobile ? <span>{formatPhone(req.mobile)}</span> : null}
                {req.phone ? <span>{formatPhone(req.phone)}</span> : null}
              </div>
            ) : null,
          ],
        ].map(([l, v]) => (
          <div key={l} style={{ marginBottom: 10 }}>
            <div
              style={{
                fontSize: 11,
                color: "#607D79",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: 0.4,
                marginBottom: 3,
              }}
            >
              {l}
            </div>
            <div style={{ fontSize: 14, fontWeight: 600, color: "#1A2E2B" }}>{v}</div>
          </div>
        ))}
        <div style={{ marginTop: 4 }}>
          <div
            style={{
              fontSize: 11,
              color: "#607D79",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 0.4,
              marginBottom: 3,
            }}
          >
            Delivery Address
          </div>
          <div style={{ fontSize: 13, color: "#1A2E2B", lineHeight: 1.5 }}>
            {req.deliveryAddress}
          </div>
          {req.nonRegisteredAddress && isStaff && (
            <div
              style={{
                marginTop: 5,
                padding: "6px 10px",
                background: "#FFEBEE",
                border: "1px solid #EF9A9A",
                borderRadius: 6,
                fontSize: 12,
                color: "#C62828",
                fontWeight: 600,
              }}
            >
              Non-registered address — confirm with shelter before dispatching.
            </div>
          )}
        </div>
      </Card>

      {isStaff && !isPicker && (
        <ShelterInfoBox shelterCode={req.shelterCode} shelterName={req.shelterName} user={user} />
      )}

      {isStaff && !isPicker && (
        <ApprovalDecisions
          req={req}
          onSave={function (savedReq) {
            onSaveNoDb(savedReq);
            setStatus(savedReq.status || status);
            if (savedReq.notes) setNotes(savedReq.notes);
          }}
          deriveStatus={deriveStatus}
          showSaved={showSaved}
          openCommentWithTemplate={function (draftText) {
            setNote(function (existing) {
              return existing.trim() ? `${existing}\n\n---\n\n${draftText}` : draftText;
            });
            setShowCommentPanel(true);
          }}
          onSchoolLockerApproved={submitToSchoolLocker}
        />
      )}

      <Card style={{ marginBottom: 14 }}>
        <SectionTitle>Request Summary</SectionTitle>
        {feeTotal > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 14,
              padding: "6px 0",
              borderBottom: `1px solid ${"#CFE0DE"}`,
            }}
          >
            <span>School Costs & Stationery</span>
            <strong>{money(feeTotal)}</strong>
          </div>
        )}
        {slTotal > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 14,
              padding: "6px 0",
              borderBottom: `1px solid ${"#CFE0DE"}`,
            }}
          >
            <span>School Locker</span>
            <strong>{money(slTotal)}</strong>
          </div>
        )}
        {uniTotal > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 14,
              padding: "6px 0",
              borderBottom: `1px solid ${"#CFE0DE"}`,
            }}
          >
            <span>Other Uniforms</span>
            <strong>{money(uniTotal)}</strong>
          </div>
        )}
        {shoeTotal > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 14,
              padding: "6px 0",
              borderBottom: `1px solid ${"#CFE0DE"}`,
            }}
          >
            <span>Shoes</span>
            <strong>{money(shoeTotal)}</strong>
          </div>
        )}
        {hasLaptops && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 14,
              padding: "6px 0",
              borderBottom: `1px solid ${"#CFE0DE"}`,
              color: "#607D79",
            }}
          >
            <span>Device</span>
            {laptopTotal > 0 ? (
              <span style={{ fontWeight: 700, color: "#1A2E2B" }}>
                {money(laptopTotal)} <span style={{ fontSize: 11, fontWeight: 400 }}>est.</span>
              </span>
            ) : (
              <span style={{ fontSize: 12 }}>see detail</span>
            )}
          </div>
        )}
        {grand > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 17,
              fontWeight: 700,
              color: "#00695C",
              paddingTop: 10,
              marginTop: 4,
            }}
          >
            <span>TOTAL</span>
            <span>{money(grand)}</span>
          </div>
        )}
      </Card>
    </div>
  );
}
